import {isObject} from 'utils';
import styles from './drawable_table.module.css';

export const DrawableTable = ({data}: Props) => {
  const isMatrix = Array.isArray(data[0]);
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          {isMatrix && <td />}
          {Object.keys(data[0]).map((column) => (
            <th key={column} scope='col'>
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((record, index) => (
          <tr key={index}>
            {isMatrix && <th>{index}</th>}
            {Object.keys(record).map((column) => (
              <td key={column}>
                {record[column] === null ? (
                  <span className={styles.null}>NULL</span>
                ) : (
                  JSON.stringify(record[column])
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

type Props = {
  data: Object[];
};

// A drawable table is an array of objects with the same keys, or an array of arrays (a matrix).
export const isDrawableTable = (rawData: string) => {
  try {
    const data = JSON.parse(rawData);
    if (Array.isArray(data)) {
      if (data.length === 0) {
        throw new Error('Empty array');
      }
      data.forEach((item) => {
        if (!isObject(item)) {
          throw new Error('Not an object');
        }
        if (Object.keys(item).length === 0) {
          throw new Error('Not a table');
        }
        if (
          !(
            Object.keys(data[0]).length === Object.keys(item).length &&
            Object.keys(data[0]).every((k) => item.hasOwnProperty(k))
          )
        ) {
          throw new Error('Elements are not the same');
        }
      });
      return true;
    } else {
      throw new Error('Its not an array');
    }
  } catch {
    return false;
  }
};
